export const classNames = {
  changeCardContent: "change-card-content",
  hideToRight: 'hide-to-right',
  hideToLeft: 'hide-to-left',
  showFromRight: 'show-from-right',
  showFromLeft: 'show-from-left',
  displayNone: 'displayNone'
}